module.exports = __webpack_public_path__ + "img/advantage1_1@2x.2f4e4f9a.png";